import React, { FC, useCallback, useMemo, useState } from 'react';
import Group from '../Group';
import { IProcurementFile } from 'src/models/procurements/Tender/types';
import { IHandledDocument, ISearchSettings } from '../../types';
import { useDocumentOccurrence } from '../../hooks';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'src/common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import styles from './index.module.scss';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import classNames from 'classnames';

export interface IDocumentsGroupProps {
  files: readonly IProcurementFile[];
  handledDocuments: IHandledDocument[];
  settings: ISearchSettings;
}

export const DocumentsGroup: FC<IDocumentsGroupProps> = props => {
  const { files, settings, handledDocuments } = props;
  const { t } = useTranslation();
  const [indicator, setIndicator] = useState(false);
  const onChange = useCallback((checkedValue: CheckboxValueType[]) => {
    setIndicator(!!checkedValue.length);
  }, []);
  const { map: occurrenceNumbers } = useDocumentOccurrence(handledDocuments, settings);
  const items = useMemo(
    () =>
      files
        .map(file => {
          return {
            loading: false,
            occurrences: occurrenceNumbers.get(file.fileName) || 0,
            value: file.fileName,
            label: file.fileName
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label)),
    [files, occurrenceNumbers]
  );
  const menu = (
    <Group
      emptyMessage={t('KeywordSearch.noDocumentsAvailable')}
      groupFormPath={'documents'}
      items={items}
      onChange={onChange}
    />
  );

  return (
    <Dropdown overlay={menu} overlayClassName={styles.overlay} trigger={['click']} placement={'topRight'}>
      <div className={classNames(styles.toggler, { [styles.active]: indicator })}>
        <span className={styles.name}>{t('KeywordSearch.documents')}</span>
        <FontAwesomeIcon icon={faCaretDown} className={styles.icon} />
      </div>
    </Dropdown>
  );
};

export default DocumentsGroup;
